
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCommandNo as ObiCommandNoElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-command-no.js';
 
 
 

 
 export const ObiCommandNo = createComponent({
   react: React,
   tagName: 'obi-command-no',
   elementClass: ObiCommandNoElement,
   events: {
     
   }
  });
 
 